module.exports = __webpack_public_path__ + "static/media/AI_6.5e235e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_6.png
// module id = 121
// module chunks = 0